
import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import { Prop, Watch } from 'vue-property-decorator';
import VideoPlayer from './videoPlayer.vue';
import CourseList from './courseList.vue';

@Component({
  components: { VideoPlayer, CourseList }
})
export default class CourseReview extends Vue {
  @Getter courseInfo: any;
  @Getter courseScore: any;
  @Getter courseScoreSet: any;
  @Getter courseFeedback: any;

  get breadcrumb() {
    const list = [{ path: '/course', name: '在线课堂' }];
    if (!!this.$route.query.category) {
      list.push({
        path: '/course?type=' + this.$route.query.category,
        name: this.courseInfo.result.categoryName
      });
    }
    list.push({ path: '', name: this.courseInfo.result.courseName });

    return list;
  }

  get videoSourses() {
    return {
      videoUrl: this.videoSource,
      imgUrl: this.courseInfo.result.imgUrl
    };
  }

  @Action('getCourseInfo') getCourseInfo: Function;
  @Action('getCourseScore') getCourseScore: Function;
  @Action('setCourseScore') setCourseScore: Function;
  @Action('setCoursePlayed') setCoursePlayed: Function;
  @Action('setCourseFeedback') setCourseFeedback: Function;

  // breadcrumb: any[] = [{ path: '/course', name: '在线课堂' }];
  videoSource: string = '';
  curCatalog: any = null;
  showStarBtn: boolean = false;
  tempScore: number = 0;
  tabVal: string = '课程目录';
  leftLetters: number = 500;
  feedback: string = '';
  feedbackTitle: any = [];
  feedQuick: any[] = [
    '声音太小',
    '播放卡顿',
    '视频不完整',
    '缺少注释',
    '其他问题'
  ];

  mounted() {
    this.getCourseScore({ courseId: this.$route.query.id || '' });
    this.getCourseInfo({ courseId: this.$route.query.id || '' });
    this.setCoursePlayed({ courseId: this.$route.query.id || '' });
  }

  formatTime(time: any) {
    if (!!time) {
      let secondTime = parseInt(time, 10); // 秒
      let minuteTime = 0; // 分
      let hourTime = 0; // 小时
      if (secondTime > 60) {
        // 如果秒数大于60，将秒数转换成整数
        // 获取分钟，除以60取整数，得到整数分钟
        minuteTime = Math.floor(secondTime / 60);
        // 获取秒数，秒数取佘，得到整数秒数
        secondTime = secondTime % 60;
        // 如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          // 获取小时，获取分钟除以60，得到整数小时
          hourTime = Math.floor(minuteTime / 60);
          // 获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = minuteTime % 60;
        }
      }
      function strTime(param: any) {
        return `${(param < 10 && '0') || ''}${param}`;
      }
      const result = `${strTime(hourTime)}时${strTime(minuteTime)}分${strTime(
        secondTime
      )}秒`;

      return result;
    }
  }

  setStar(val: any) {
    this.showStarBtn = true;
  }

  setCourse(param: any) {
    this.videoSource = param.videoDownloadUrl || '';
    this.curCatalog = param.catalogId;
  }

  submitScore() {
    this.setCourseScore({
      courseId: this.$route.query.id || '',
      score: this.tempScore
    }).then(() => {
      this.getCourseScore({ courseId: this.$route.query.id || '' });
      this.showStarBtn = false;
    });
  }

  handleSubmit() {
    const params = {
      catalogId: this.curCatalog,
      courseId: this.courseInfo.result.courseId,
      title: this.feedbackTitle.join(' '),
      content: this.feedback
    };
    this.setCourseFeedback(params).then(() => {
      this.feedbackTitle = [];
      this.feedback = '';
    });
  }

  handleQuickfeed(val: any) {
    this.feedback = val;
  }

  @Watch('feedback', { immediate: true, deep: true })
  changeFeedback(feedback: any) {
    this.leftLetters = 500 - feedback.length;
  }

  @Watch('courseScore.result.userScore', { immediate: true, deep: true })
  changeScore(score: any) {
    this.tempScore = score || 0;
  }
}
